import React, { Fragment } from 'react';
import GatsbyLink from 'gatsby-link';
import { Flex, Button } from 'rebass';

const VendorPagination = props => {
  const { numPages, currentPage, vendor, menu } = props;
  const showNumbers = 2;

  let prevLink = false;
  let nextLink = false;
  let menuHandle = '';

  if (menu) {
    menuHandle = menu.handle === 'epink' ? 'caroline-causse-clothing' : menu.handle;
  }

  let vendorHandle = vendor.slug === 'epink' ? 'caroline-causse-clothing' : vendor.slug;

  if (currentPage !== 1) {
    if (!menu || vendorHandle === menuHandle)  {
      prevLink = '/' + vendorHandle + '/' + (currentPage - 1);
    } else {
      prevLink = '/' + vendorHandle + '-' + menuHandle + '/' + (currentPage - 1);
    }
  }
  if (currentPage === 2) {
    if (!menu || vendorHandle === menuHandle)  {
      prevLink = '/' + vendorHandle;
    } else {
      prevLink = '/' + vendorHandle + '-' + menuHandle;
    }
  }
  if (currentPage !== numPages) {
    if (!menu || vendorHandle === menuHandle)  {
      nextLink = '/' + vendorHandle + '/' + (currentPage + 1);
    } else {
      nextLink = '/' + vendorHandle + '-' + menuHandle + '/' + (currentPage + 1);
    }
  }

  return (
    <Fragment>
      {numPages > 1 ? (
        <Flex justifyContent="center">
          {prevLink ? (
            <Button
              as={GatsbyLink}
              to={prevLink}
              mx={2}
              rel="prev"
              variant="pagination"
            >
              {'<'}
            </Button>
          ) : (
            ''
          )}
          {Array.from({ length: numPages }).map((_, i) => {
            let pageNum = i + 1;

            if (
              pageNum >= Math.max(1, currentPage - showNumbers) &&
              pageNum <= Math.min(currentPage + showNumbers, numPages)
            ) {
              if (pageNum === currentPage) {
                return (
                  <Button mx={2} variant="pagination-active" key={pageNum}>
                    {pageNum}
                  </Button>
                );
              } else {
                let link;

                if (!menu || vendorHandle === menuHandle)  {
                  pageNum === 1
                    ? (link = '/' + vendorHandle)
                    : (link = '/' + vendorHandle + '/' + pageNum);
                } else {
                  pageNum === 1
                    ? (link = '/' + vendorHandle + '-' + menuHandle)
                    : (link = '/' + vendorHandle + '-' + menuHandle + '/' + pageNum);
                }
                  return (
                  <Button
                    as={GatsbyLink}
                    to={link}
                    mx={2}
                    variant="pagination"
                    key={pageNum}
                  >
                    {pageNum}
                  </Button>
                );
              }
            } else {
              return '';
            }
          })}
          {nextLink ? (
            <Button
              as={GatsbyLink}
              to={nextLink}
              mx={2}
              rel="next"
              variant="pagination"
            >
            </Button>
          ) : (
            ''
          )}
        </Flex>
      ) : (
        ''
      )}
    </Fragment>
  );
};

export default VendorPagination;
